import { createFileRoute, useRouter } from "@tanstack/react-router";

import { PhoneVerificationConnector } from "@pages/phone-verification";

export const Route = createFileRoute("/_private/phone-verify")({
  component: RouteComponent,
});

function RouteComponent() {
  const router = useRouter();
  const toProfile = () => {
    router.navigate({
      search: {
        tab: "verify",
      },
      to: "/profile",
    });
  };

  return (
    <PhoneVerificationConnector
      toProfile={toProfile}
      onGoBack={router.history.back}
    />
  );
}
